import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

const KINDS = { lender: "Lender", agency: "Government agency", landlord: "Landlord", other: "Other" };
const EMPTY = { name: "", email: "", organization: "", kind: "lender", phone: "", message: "" };

export function InquiryDialog({ badge, onClose }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post(`/badge-wall/${badge.badge_id}/inquiry`, f); toast.success(`Inquiry sent to ${badge.company}`); onClose(); }
    catch (e2) { toast.error(formatErr(e2)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="inquiry-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Contact {badge.company}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">We'll email your message and contact details to the business. Their email stays private until they reply.</p>
        <form onSubmit={submit} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Your name</Label><Input required minLength={2} className="mt-1" value={f.name} onChange={set("name")} data-testid="inquiry-name-input" /></div>
            <div><Label>Work email</Label><Input required type="email" className="mt-1" value={f.email} onChange={set("email")} data-testid="inquiry-email-input" /></div>
            <div><Label>Organization</Label><Input required minLength={2} className="mt-1" value={f.organization} onChange={set("organization")} data-testid="inquiry-org-input" /></div>
            <div><Label>You are a</Label>
              <Select value={f.kind} onValueChange={(v) => setF({ ...f, kind: v })}>
                <SelectTrigger className="mt-1" data-testid="inquiry-kind-select"><SelectValue /></SelectTrigger>
                <SelectContent>{Object.entries(KINDS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          </div>
          <div><Label>Phone (optional)</Label><Input maxLength={30} className="mt-1" value={f.phone} onChange={set("phone")} data-testid="inquiry-phone-input" /></div>
          <div><Label>Message</Label><Textarea required minLength={10} maxLength={2000} rows={4} className="mt-1" placeholder="e.g. We offer SBA microloans and would like to discuss financing options." value={f.message} onChange={set("message")} data-testid="inquiry-message-input" /></div>
          <Button type="submit" disabled={busy} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="inquiry-submit-button">{busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Send className="h-4 w-4 mr-2" />}Send inquiry</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
